/**
 * Pure TypeScript utilities to securely initialize and manage the global 'q' variable
 * This replaces the unsafe inline script declaration
 */

// Extend the global interfaces to properly type the 'q' property
declare global {
  interface Window {
    q: QGlobals
  }

  var q: QGlobals
}

/**
 * Initialize the global 'q' variable on the window object
 * This must be called before the application bootstraps to ensure
 * the variable is available throughout the application
 */
export function initializeGlobalQ(): void {
  // Initialize the global 'q' variable as an empty object
  // It will be populated later by the translation service
  const emptyGlobals = {} as QGlobals

  if (typeof window !== 'undefined') {
    window.q = emptyGlobals
    globalThis.q = window.q
  } else if (typeof globalThis !== 'undefined') {
    // For server-side rendering or Node.js environments (e.g.: Tests)
    globalThis.q = emptyGlobals
  }
}

/**
 * Set the global 'q' variable (used by translation service)
 * @param {QGlobals} globals The QGlobals object to set
 */
export function setGlobalQ(globals: QGlobals): void {
  if (typeof window !== 'undefined') {
    window.q = globals
    globalThis.q = window.q
  } else if (typeof globalThis !== 'undefined') {
    globalThis.q = globals
  }
}
